import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonDirective, EntityWithUuid, NkCardListItemAbstractComponent } from '@nk/ui-lib';
import { LOADING_STATE_HANDLER_SERVICE_TOKEN } from '@nk/utils-lib';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ScreeningInputParamsService } from '../../services/screening-input-params.service';
import { isScreeningRemovePersonParams, ScreeningRemovePersonParams } from '../../utils/screening.utils';
import { ScreeningRemovePersonModalComponent } from '../screening-remove-person-modal/screening-remove-person-modal.component';

@Component({
  selector: 'nk-screening-remove-person-card-list-item',
  imports: [ButtonDirective, TranslateModule],
  templateUrl: './screening-remove-person-card-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreeningRemovePersonCardListItemComponent<Entity extends EntityWithUuid>
  extends NkCardListItemAbstractComponent<Entity>
  implements OnInit
{
  public params: Signal<ScreeningRemovePersonParams | null> = computed(() => {
    const value = this.valueSignal();
    if (value && value.entity && value.prop) {
      const item = value.entity && value.entity[value.prop];
      if (isScreeningRemovePersonParams(item)) {
        return item;
      }
    }
    return null;
  });
  public screeningEntitiesInputParams = computed(() => {
    return this._screeningInputParamsService.screeningInputParams();
  });
  public isPrintVersion = signal<boolean>(false);
  private _screeningInputParamsService = inject(ScreeningInputParamsService);
  private _reportLoadingStateService = inject(LOADING_STATE_HANDLER_SERVICE_TOKEN, { optional: true });
  private _modalService = inject(BsModalService);

  public ngOnInit(): void {
    if (this._reportLoadingStateService) {
      this.isPrintVersion.set(true);
    }
  }

  public openScreeningRemovePersonModal(params: ScreeningRemovePersonParams): void {
    if (params.screeningEntityUuid && params.monitoringOriginEntityUuid) {
      const initialState: ScreeningRemovePersonParams = {
        screeningConfigUuid: params.screeningConfigUuid,
        appMembershipUuid: params.appMembershipUuid,
        entityMonitoringTypeUuid: params.entityMonitoringTypeUuid,
        monitoringOriginEntityUuid: params.monitoringOriginEntityUuid,
        screeningEntityUuid: params.screeningEntityUuid,
      };
      this._modalService.show(ScreeningRemovePersonModalComponent, {
        initialState,
      });
    }
  }
}
